import { InputSideController, InputSideControllerEnable } from './InputSide/InputSideController';
import { InputTextProps } from './type';
import { InputBase } from './InputBase';

export class InputText extends InputBase<
  InputTextProps,
  InputSideController<InputTextProps>,
  InputSideControllerEnable<InputTextProps>
> {
  constructor(data: InputTextProps) {
    super(data, {
      InputSide: InputSideController,
      InputSideEnable: InputSideControllerEnable,
    });
  }

  getValue() {
    return this.data.value ?? '';
  }

  setValue(text: string) {
    this.data.value = text;
    this.inputView.setValue(text);
  }
}
